module.exports = __webpack_public_path__ + "img/扶梯1.f8df7611.png";